<app-side-menu>
  <div class="ap-report-container">
    <app-financial-reports-nav></app-financial-reports-nav>

    <div class="row mb-4">
      <div class="col-12">
        <div class="page-header d-flex flex-wrap justify-content-between align-items-start gap-3">
          <div>
            <h1 class="page-title">
              <i class="fas fa-file-invoice-dollar me-3"></i>
              Posição de contas a pagar
            </h1>
            <p class="page-subtitle mb-0">
              KPIs de aging, pendências, vencidos e pagamentos no período selecionado.
            </p>
          </div>
          <div class="d-flex flex-wrap gap-2">
            <button type="button" class="btn btn-outline-primary" (click)="openParamsModal()" [disabled]="loading">
              <i class="fas fa-sliders me-2"></i>
              Personalizar relatório
            </button>
            <button
              type="button"
              class="btn btn-success"
              (click)="exportExcel()"
              [disabled]="loading || isExporting || !report">
              <i class="fas fa-file-excel me-2"></i>
              Excel
            </button>
            <button
              type="button"
              class="btn btn-danger"
              (click)="exportPdf()"
              [disabled]="loading || isExporting || !report">
              <i class="fas fa-file-pdf me-2"></i>
              PDF
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="ap-report-card" *ngIf="report?.summary as s">
      <div class="ap-report-meta">
        <span><i class="fas fa-calendar me-1"></i>{{ s.periodDescription || appliedPeriodLabel }}</span>
        <span>
          <i class="fas fa-calendar-check me-1"></i>
          Pagamentos: {{ formatDate(s.paymentPeriodFrom) }} — {{ formatDate(s.paymentPeriodTo) }}
        </span>
        <span><i class="fas fa-building me-1"></i>Centro de custo: {{ appliedCostCenterLabel }}</span>
        <span *ngIf="appliedCostCenterId != null">
          <i class="fas fa-sitemap me-1"></i>
          {{ appliedIncludeChildCostCenters ? 'Inclui centros filhos' : 'Somente centro selecionado' }}
        </span>
      </div>

      <div class="ap-kpi-row">
        <div class="ap-kpi ap-kpi-pending">
          <span class="ap-kpi-label">Pendentes</span>
          <span class="ap-kpi-count">{{ s.pendingCount }} títulos</span>
          <span class="ap-kpi-value">{{ formatCurrency(s.pendingAmount) }}</span>
        </div>
        <div class="ap-kpi ap-kpi-overdue">
          <span class="ap-kpi-label">Vencidos</span>
          <span class="ap-kpi-count">{{ s.overdueCount }} títulos</span>
          <span class="ap-kpi-value">{{ formatCurrency(s.overdueAmount) }}</span>
        </div>
        <div class="ap-kpi ap-kpi-paid">
          <span class="ap-kpi-label">Pagos no período</span>
          <span class="ap-kpi-count">{{ s.paidInPeriodCount }} títulos</span>
          <span class="ap-kpi-value">{{ formatCurrency(s.paidInPeriodAmount) }}</span>
        </div>
        <div class="ap-kpi ap-kpi-open">
          <span class="ap-kpi-label">Total em aberto (aging)</span>
          <span class="ap-kpi-count">{{ s.openAging.totalCount }} títulos</span>
          <span class="ap-kpi-value">{{ formatCurrency(s.openAging.totalAmount) }}</span>
        </div>
      </div>

      <div class="row g-4">
        <div class="col-lg-6">
          <h3 class="ap-section-title">Aging em aberto</h3>
          <div class="table-responsive">
            <table class="table table-sm ap-table">
              <thead>
                <tr>
                  <th>Faixa</th>
                  <th class="text-end">Qtd</th>
                  <th class="text-end">Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let b of s.openAging.buckets">
                  <td>{{ b.label }}</td>
                  <td class="text-end">{{ b.count }}</td>
                  <td class="text-end">{{ formatCurrency(b.amount) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-lg-6">
          <h3 class="ap-section-title">Por categoria (em aberto)</h3>
          <div class="table-responsive">
            <table class="table table-sm ap-table">
              <thead>
                <tr>
                  <th>Categoria</th>
                  <th class="text-end">Qtd</th>
                  <th class="text-end">Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of s.openByCategory">
                  <td>{{ row.key }}</td>
                  <td class="text-end">{{ row.count }}</td>
                  <td class="text-end">{{ formatCurrency(row.amount) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-lg-6">
          <h3 class="ap-section-title">Por fornecedor (em aberto)</h3>
          <div class="table-responsive">
            <table class="table table-sm ap-table">
              <thead>
                <tr>
                  <th>Fornecedor</th>
                  <th class="text-end">Qtd</th>
                  <th class="text-end">Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of s.openBySupplier">
                  <td>{{ row.entityName }}</td>
                  <td class="text-end">{{ row.count }}</td>
                  <td class="text-end">{{ formatCurrency(row.amount) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="col-lg-6">
          <h3 class="ap-section-title">Por centro de custo (em aberto)</h3>
          <div class="table-responsive">
            <table class="table table-sm ap-table">
              <thead>
                <tr>
                  <th>Centro de custo</th>
                  <th class="text-end">Qtd</th>
                  <th class="text-end">Valor</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of s.openByCostCenter">
                  <td>{{ row.costCenterName }}</td>
                  <td class="text-end">{{ row.count }}</td>
                  <td class="text-end">{{ formatCurrency(row.amount) }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <p class="text-muted small mt-3 mb-0" *ngIf="s.pending?.itemsTruncated || s.overdue?.itemsTruncated">
        A API pode truncar itens na visualização. Use <strong>Exportar Excel</strong> para a lista completa.
      </p>
    </div>

    <div *ngIf="loading" class="ap-loading">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Carregando...</span>
      </div>
    </div>

    <div *ngIf="!loading && error" class="alert alert-danger">{{ error }}</div>

    <div *ngIf="!loading && !error && !report" class="ap-empty">
      <i class="fas fa-chart-pie"></i>
      <p>Clique em <strong>Personalizar relatório</strong> para gerar os dados.</p>
    </div>
  </div>

  <app-modal
    [isOpen]="showParamsModal"
    title="Personalizar relatório"
    size="md"
    (close)="closeParamsModal()">
    <div class="report-params-form">
      <div class="mb-3">
        <label class="form-label">Período</label>
        <select class="form-select" [(ngModel)]="draftPeriod">
          <option *ngFor="let opt of periodOptions" [ngValue]="opt.value">{{ opt.label }}</option>
        </select>
        <div class="form-text">
          Presets: últimos 7/30/90 dias, mês atual ou mês anterior (conforme API).
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">Centro de custo</label>
        <select class="form-select" [(ngModel)]="draftCostCenterId">
          <option [ngValue]="null">Todos</option>
          <option *ngFor="let cc of costCenters" [ngValue]="cc.id">{{ cc.name }}</option>
        </select>
      </div>

      <div class="mb-4" *ngIf="draftCostCenterId != null">
        <div class="form-check">
          <input
            class="form-check-input"
            type="checkbox"
            id="includeChildCc"
            [(ngModel)]="draftIncludeChildCostCenters" />
          <label class="form-check-label" for="includeChildCc">
            Incluir centros de custo filhos
          </label>
        </div>
      </div>

      <div class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-outline-secondary" (click)="closeParamsModal()">Cancelar</button>
        <button type="button" class="btn btn-primary" (click)="applyParamsAndLoad()">
          <i class="fas fa-play me-2"></i>
          Gerar relatório
        </button>
      </div>
    </div>
  </app-modal>
</app-side-menu>
